var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseNormal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#767571",
  fillRule: "evenodd",
  d: "M.286 13.714a.985.985 0 0 0 1.39 0l5.326-5.323 5.31 5.323a.984.984 0 0 0 1.398-.01.985.985 0 0 0 0-1.388L8.4 6.996l5.311-5.308A.99.99 0 0 0 12.312.29L7.006 5.6 1.704.29A.985.985 0 1 0 .316 1.688L5.61 6.997.286 12.326a.985.985 0 0 0 0 1.388",
  clipRule: "evenodd"
})));
export default SvgCloseNormal;